import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../config";

export default function PostPoolCareBusinessFranchise() {
 
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  const [listingType, setListingType] = useState("business");

  const [form, setForm] = useState({
    business_title: "",
    business_description: "",
    yearly_revenue: "",
    clients_count: "",
    total_client_value: "",

    franchise_type: "new",
    franchise_brand: "",
    territory_name: "",
    territory_type: "exclusive",
    number_of_clients: "",
    avg_job_price: "",

    vehicle_included: "0",
    vehicle_details: "",
    equipment_included: "0",
    equipment_details: "",

    work_guarantee: "0",
    work_guarantee_amount: "",
    work_guarantee_period: "",

    price: "",
    suburb: "",
    state: "",
    postcode: "",
    enquiry_only: "0",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const n = (v) => {
    if (v === "" || v === null || v === undefined) return 0;
    const num = Number(v);
    return Number.isFinite(num) ? num : 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user?.id) {
      alert("You must be logged in");
      return;
    }

    if (!form.price) {
      alert("Sale price is required");
      return;
    }

    try {
      const createRes = await axios.post(
        `${API_BASE_URL}/api/poolcare/business-franchise/create`,
        {
          user_id: user.id,
          listing_type: listingType,

          business_title: form.business_title,
          business_description: form.business_description,

          yearly_revenue: n(form.yearly_revenue),
          clients_count: n(form.clients_count),
          total_client_value: n(form.total_client_value),

          franchise_type: form.franchise_type,
          franchise_brand: form.franchise_brand,
          territory_name: form.territory_name,
          territory_type: form.territory_type,
          number_of_clients: n(form.number_of_clients),
          avg_job_price: n(form.avg_job_price),

          vehicle_included: n(form.vehicle_included),
          vehicle_details: form.vehicle_details,

          equipment_included: n(form.equipment_included),
          equipment_details: form.equipment_details,

          work_guarantee: n(form.work_guarantee),
          work_guarantee_amount: n(form.work_guarantee_amount),
          work_guarantee_period: form.work_guarantee_period,

          // ✅ REQUIRED BY BACKEND (FIX)
          starter_clients_available: 0,
          starter_clients_count: 0,
          starter_clients_total_value: 0,
          starter_clients_avg_job_price: 0,
          training_included: 0,

          price: n(form.price),
          suburb: form.suburb || "",
          state: form.state || "",
          postcode: form.postcode || "",
          enquiry_only: n(form.enquiry_only),
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!createRes.data?.success) {
        alert(createRes.data?.message || "Failed to create listing");
        return;
      }

      const listingId = createRes.data.listingId;

      if (form.enquiry_only === "1") {
        alert("Listing created (Enquiry Only)");
        window.location.href = "/dashboard";
        return;
      }

      const checkoutRes = await axios.post(
        `${API_BASE_URL}/api/poolcare/business-franchise/payments/create-checkout`,
        {
          listingId,
          user_id: user.id,
          listing_type: listingType,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!checkoutRes.data?.checkout_url) {
        alert("Unable to start payment");
        return;
      }

      window.location.href = checkoutRes.data.checkout_url;
    } catch (err) {
      console.error("❌ Submit error:", err.response?.data || err);
      alert(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Server error"
      );
    }
  };

  const container = {
    maxWidth: "700px",
    margin: "120px auto 40px",
    background: "#fff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  };

  const header = {
    color: "#2e7d32",
    fontWeight: "bold",
    fontSize: "1.6rem",
    marginBottom: "20px",
  };

  const section = {
    background: "#e8f5e9",
    padding: "10px",
    borderRadius: "6px",
    marginTop: "20px",
    fontWeight: "bold",
    color: "#1b5e20",
  };

  const input = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    marginBottom: "12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  const checkboxRow = {
    marginTop: "10px",
    marginBottom: "10px",
  };

  const button = {
    width: "100%",
    padding: "14px",
    background: "#2e7d32",
    color: "#fff",
    border: "none",
    fontSize: "1.2rem",
    fontWeight: "bold",
    borderRadius: "8px",
    marginTop: "25px",
    cursor: "pointer",
  };

  return (
    <div style={container}>
      <div style={header}>Create Pool Care Business Listing</div>

      <form onSubmit={handleSubmit}>
        <div style={section}>Listing Type</div>
        <select
          style={input}
          value={listingType}
          onChange={(e) => setListingType(e.target.value)}
        >
          <option value="business">Business</option>
          
        </select>

        {listingType === "business" && (
          <>
            <div style={section}>Business Information</div>
            <input
              style={input}
              name="business_title"
              placeholder="Business Title"
              value={form.business_title}
              onChange={handleChange}
            />
            <textarea
              style={input}
              rows="3"
              name="business_description"
              placeholder="Business Description"
              value={form.business_description}
              onChange={handleChange}
            />
            <input
              style={input}
              name="yearly_revenue"
              placeholder="Yearly Revenue"
              value={form.yearly_revenue}
              onChange={handleChange}
            />
            <input
              style={input}
              name="clients_count"
              placeholder="Clients Count"
              value={form.clients_count}
              onChange={handleChange}
            />
            <input
              style={input}
              name="total_client_value"
              placeholder="Total Client Value"
              value={form.total_client_value}
              onChange={handleChange}
            />
          </>
        )}

        {false && (
          <>
            <div style={section}>Franchise Information</div>
            <select
              style={input}
              name="franchise_type"
              value={form.franchise_type}
              onChange={handleChange}
            >
              <option value="new">New Franchise</option>
              <option value="existing">Existing Franchise</option>
            </select>
            <input
              style={input}
              name="franchise_brand"
              placeholder="Franchise Brand"
              value={form.franchise_brand}
              onChange={handleChange}
            />
            <input
              style={input}
              name="territory_name"
              placeholder="Territory Name"
              value={form.territory_name}
              onChange={handleChange}
            />
            <select
              style={input}
              name="territory_type"
              value={form.territory_type}
              onChange={handleChange}
            >
              <option value="exclusive">Exclusive</option>
              <option value="non-exclusive">Non-exclusive</option>
            </select>
            <input
              style={input}
              name="number_of_clients"
              placeholder="Number of Clients"
              value={form.number_of_clients}
              onChange={handleChange}
            />
            <input
              style={input}
              name="avg_job_price"
              placeholder="Average Job Price"
              value={form.avg_job_price}
              onChange={handleChange}
            />
          </>
        )}

        <div style={section}>Assets Included</div>

        <div style={checkboxRow}>
          <label>
            <input
              type="checkbox"
              checked={form.vehicle_included === "1"}
              onChange={(e) =>
                setForm({
                  ...form,
                  vehicle_included: e.target.checked ? "1" : "0",
                })
              }
            />{" "}
            Vehicle Included
          </label>
        </div>

        {form.vehicle_included === "1" && (
          <textarea
            style={input}
            name="vehicle_details"
            placeholder="Vehicle Details"
            value={form.vehicle_details}
            onChange={handleChange}
          />
        )}

        <div style={checkboxRow}>
          <label>
            <input
              type="checkbox"
              checked={form.equipment_included === "1"}
              onChange={(e) =>
                setForm({
                  ...form,
                  equipment_included: e.target.checked ? "1" : "0",
                })
              }
            />{" "}
            Equipment Included
          </label>
        </div>

        {form.equipment_included === "1" && (
          <textarea
            style={input}
            name="equipment_details"
            placeholder="Equipment Details"
            value={form.equipment_details}
            onChange={handleChange}
          />
        )}

        <div style={section}>Work Guarantee</div>

        <div style={checkboxRow}>
          <label>
            <input
              type="checkbox"
              checked={form.work_guarantee === "1"}
              onChange={(e) =>
                setForm({
                  ...form,
                  work_guarantee: e.target.checked ? "1" : "0",
                })
              }
            />{" "}
            Work Guarantee
          </label>
        </div>

        {form.work_guarantee === "1" && (
          <>
            <input
              style={input}
              name="work_guarantee_amount"
              placeholder="Guarantee Amount"
              value={form.work_guarantee_amount}
              onChange={handleChange}
            />
            <input
              style={input}
              name="work_guarantee_period"
              placeholder="Guarantee Period"
              value={form.work_guarantee_period}
              onChange={handleChange}
            />
          </>
        )}

        <div style={section}>Location</div>
        <input
          style={input}
          name="suburb"
          placeholder="Suburb"
          value={form.suburb}
          onChange={handleChange}
        />
    <select
  style={input}
  name="state"
  value={form.state}
  onChange={handleChange}
>
  <option value="">Select State</option>
  <option value="VIC">VIC</option>
  <option value="NSW">NSW</option>
  <option value="QLD">QLD</option>
  <option value="SA">SA</option>
  <option value="WA">WA</option>
  <option value="TAS">TAS</option>
  <option value="NT">NT</option>
  <option value="ACT">ACT</option>
</select>
        <input
          style={input}
          name="postcode"
          placeholder="Postcode"
          value={form.postcode}
          onChange={handleChange}
        />

        <div style={section}>Sale</div>
        <input
          style={input}
          name="price"
          placeholder="Sale Price ($)"
          value={form.price}
          onChange={handleChange}
        />

      

        <button type="submit" style={button}>
          Continue to Payment
        </button>
      </form>
    </div>
  );
}
